import React, { useEffect } from 'react';
import { useCustomTextInput } from '../hooks/useCustomTextInput';
import { Activity } from '../types';
import styles from './UserMessage.module.css';

export const UserMessage: React.FC<{
    activity: Activity;
    idx: number;
}> = ({ activity, idx }) => {
    const { setCustomTextInput } = useCustomTextInput();

    useEffect(() => {
        setCustomTextInput('default');
  }, []); // eslint-disable-line

    let text = activity?.value?.displayText || activity.text;
    if (typeof text === 'string') {
        text = text.replaceAll('|', ', ');
    }
    const isPostBack = activity?.channelData?.postBack;
    const displayPostBack =
        activity?.value?.displayText || activity?.value?.title;

    return !isPostBack || displayPostBack ? (
        // we use sendPostBack when we want to override the default sendMessage (just displaying user text)
        // we may use it either to send custom formatted data, or to send a hidden user message (not displayed in UI)
        // so here we say to render null if it's a postBack message and is not a dropdown
        // we do want to render a user message for a dropdown - the text in the field activity.value.title
        // "activity.value" exists for a multiple choice kind of attachment (e.g. multi-select, dropdown)
        // it currently will also exist when the user is logged in - we populate activity.value with their token for every user message.
        // we don't want to display user message for multi-select, which is when "Array.isArray(activity.value)" or "activity.value.multiSelect" is true.
        <div className={styles.userUtterance} key={`utterance-${idx}`}>
            <div className={styles.userUtteranceBubble}>
                {activity.value
                    ? Array.isArray(activity.value)
                        ? activity.value.join(', ') // multiple choice (e.g. multi-select) (this is here in case we decide to render user message for multi-select)
                        : activity.value.title || text // title is for dropdown, text is normal msg
                    : text}
            </div>
        </div>
    ) : null;
};
